import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';
import Modal from '~/commons/components/Modal.jsx';
import Padding from '../layout/Padding.jsx';

const CompetitionSmry = () => {
  const [res, req] = useHttpStatus();
  const [, attemptReq] = useHttpStatus();
  const [startModal, setStartModal] = useState(false);

  useEffect(() => {
    req({ url: 'api/quiz/competitions/self' });
  }, []);

  return (
    <PageHttp res={res}>
      {(comp) => {
        const answer = comp.answers[0];
        const canAnswer = !answer && comp?.allow?.allowed;
        const inProgress = answer
          && !answer.submittedAt
          && moment(answer.createdAt)
            .add(comp.duration, 'm')
            .isAfter();
        return (
          <div>
            {/* Modal before start */}
            <Modal
              show={startModal}
              onHide={() => setStartModal(false)}
              centered
            >
              <div className="text-center p-4">
                <div className="text-secondary">{comp.beforeStartMsg}</div>
                <div className="mt-4">
                  <button
                    onClick={() => setStartModal(false)}
                    className="m-2 btn btn-primary btn-fixed-w"
                  >
                    取消
                  </button>
                  <Link
                    to={'/app/competition'}
                    className="m-2 btn btn-outline-primary btn-fixed-w"
                  >
                    確定
                  </Link>
                </div>
              </div>
            </Modal>

            {comp && (
              <div className="
              assignments-slider
              position-relative m-0
              bg-light
              ">

                {/* cover img */}
                { (
                  <div className="container-fluid p-0 pos-abs-fill cover-imgs">
                    <div
                         className="img-bg-cover bg-no-repeat bg-left bg-contain"
                          style={{
                            backgroundImage: `url('${comp.coverImg}')`,
                            backgroundSize: 'center',
                          }}
                        ></div>
                          <img
                  // src={'assets/img/background_logo.jpg'}
                  style={{
                    objectFit: 'fill', width: '50%', minWidth: 380, position: 'absolute', overflow: 'hidden', zIndex: 1, top: '15%',
                  }}
                />
                  </div>

                )}

                  {/* {comp.comp && (
                  <img
                  src={`assets/img/background_logo.jpg`}
                  style={{ height: 500,width:500,position:"absolute",overflow:"hidden",zIndex:100 }}
                />
                )} */}
                {/* details */}
                <div className="container-fluid p-0">
                  <div className="row no-gutters justify-content-end">
                    <div className="col-12 col-lg-6 py-4 bg-white">
                      <Padding>
                        <div className="pt-2">
                          {comp.dates && (
                            [comp.dates[0], comp.dates.slice(-1)[0]]
                              .filter((v, i) => comp.dates.indexOf(v) === i)
                              .map((d) => moment(d).format('LL'))
                              .join(' - ')
                          )}
                          &nbsp;
                          <img
                            src={`assets/img/${
                              comp.answers[0]
                                ? 'read.svg'
                                : 'unfinished.svg'
                            }`}
                            style={{ width: '20px' }}
                          />
                        </div>
                        <h2 className="my-3">
                          {comp.title}
                        </h2>
                        <div className="pb-1">
                          <Html>{comp.description}</Html>
                        </div>
                        <div className="text-right mx-n2">
                          {answer && !inProgress && (
                            <a
                              className={`
                                btn btn-primary mx-2 mt-2
                                ${!comp?.allow?.awards ? 'disabled' : ''}
                              `}
                              target="_blank"
                              {...!comp?.allow?.awards ? {
                                disabled: true,
                              } : {
                                href: 'api/quiz/awards',
                              }}
                            >
                              我的電子證書
                            </a>
                          )}
                          <a
                            onClick={() => {
                              if (canAnswer) {
                                attemptReq({
                                  method: 'post',
                                  url: 'api/quiz/answers/attempt',
                                });
                                setStartModal(true);
                              }
                            }}
                            className={`
                              btn btn-${!canAnswer ? 'light' : 'primary'}
                              px-4 py-2 mx-2 mt-2
                              ${!canAnswer ? 'disabled' : ''}
                            `}
                            disabled={!canAnswer}
                          >
                            {!canAnswer && (
                              inProgress ? '問答進行中' : comp.completedMsg
                            )}
                            {canAnswer && '開始作答'}
                            &nbsp;
                            {canAnswer && (
                              <img
                                className="mr-3"
                                src={`assets/img/long-arrow-right${comp.answers[0] ? '-blk' : ''}.svg`}
                                style={{ width: '38px', height: '9px' }}
                              />
                            )}
                        </a>
                        </div>
                      </Padding>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      }}
    </PageHttp>
  );
};

export default CompetitionSmry;
